// The wizard steps are a pure function of the project. A project without a
// formStatus is either missing or a failed fetch — both render NotFound.
export const derivePages = (project) => {
  if (!project?.formStatus) return ['NOT_FOUND']

  if (project.formStatus === 'UNOPENED') {
    if (!project.useCountdown) return ['UNOPENED']
    return project.bookingEnabled
      ? ['START', 'USER', 'INTERESTS', 'END']
      : ['START', 'USER', 'END']
  }

  if (project.formStatus === 'CLOSED') return ['CLOSED']

  if (project.interestSignup) {
    return project.bookingEnabled
      ? ['USER', 'INTERESTS', 'END']
      : ['USER', 'END']
  }

  return project.bookingEnabled
    ? ['START', 'USER', 'INTERESTS', 'END']
    : ['START', 'USER', 'END']
}
